<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
      <el-form-item label="课节名称" prop="sectionName">
        <el-input v-model="dataForm.sectionName" placeholder="课节名称"></el-input>
      </el-form-item>
      <el-form-item label="视频地址" prop="videoSrc">
        <div class="editPage__video">
          <div class="img__con">
            <el-upload
                    class="avatar-uploader"
                    :action="uploadImgUrl"
                    :data="uploadImgData"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload"
                    :on-progress="uploadVideoProcess"
            >
              <video width="100%" v-if="this.dataForm.videoSrc" controls="controls" :key="menuKey">
                <source :src="this.dataForm.videoSrc" type="video/mp4" />
              </video>
              <!-- <img v-if="imageUrl" :src="imageUrl" class="avatar" /> -->
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <el-progress
                      v-if="videoFlag == true"
                      type="line"
                      :percentage="videoUploadPercent"
                      style="margin-top: 30px"
              ></el-progress>
            </el-upload>
            <p>
              说明: 视频格式为mp4格式，每个视频大小不超过300MB
            </p>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="积分" prop="score">
        <el-input v-model="dataForm.score" placeholder="积分"></el-input>
      </el-form-item>
      <el-form-item label="排序" prop="weight">
        <el-input-number v-model="dataForm.weight" :min="1" label="排序"></el-input-number>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import Cookies from 'js-cookie'
export default {
  data () {
    return {
      // 视频上传
      uploadImgUrl: '',
      uploadImgData: { busiName: 32 },
      // 应付多个组件的情况 记录当前组件的key值
      componentKey: null,
      menuKey: 1, // 用来强制刷新
      videoFlag: false, // 进度条相关的
      videoUploadPercent: 0, // 进度条相关的
      visible: false,
      dataForm: {
        id: '',
        sectionName: '',
        videoSrc: '',
        score: '',
        viewNum: '',
        thumbNum: '',
        creator: '',
        updater: '',
        createDate: '',
        updateDate: '',
        schoolId: '',
        weight: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        sectionName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        score: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 上传成功的函数
    handleAvatarSuccess (res, file) {
      // 进度条恢复到初始状态
      this.videoFlag = false
      this.videoUploadPercent = 0
      ++this.menuKey
      this.dataForm.videoSrc = res.data.src
      // // 这里是向父级传值，不需要就去掉
      // this.$emit('childRightFn', {
      //   ...this.rightData,
      //   ...{ imageUrl: this.imageUrl },
      //   ...{ props: { src: this.imageUrl } }
      // })
    },
    beforeAvatarUpload (file) {
      //   file.type === "image/jpg" ||
      //   file.type === "image/png";
      const isMp4 = file.type === 'video/mp4'
      // 限制文件最大不能超过 300M
      const isLt2M = file.size / 1024 / 1024 < 300

      if (!isMp4) {
        this.$message.error('视频只能是mp4格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 300MB!')
      }
      return isMp4 && isLt2M
    },
    // 进度条
    uploadVideoProcess (event, file, fileList) {
      this.videoFlag = true
      this.videoUploadPercent = parseInt(file.percentage)
    },
    init () {
      console.log(this.dataForm.onlineCourseId)
      this.uploadImgUrl = `${window.SITE_CONFIG.apiURL}/sys/oss/upload?token=${Cookies.get('token')}`
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get('/parentStarLicense/onlineCourseSection/' + this.dataForm.id).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      // 两位位小数的正则表达式
      const r = /^([0-9]\d*(\.\d{1,2})?|([0](\.([0][1-9]|[1-9]\d{0,1}))))$/
      if (!r.test(this.dataForm.score)) {
        return this.$message.error('积分最多支持小数点后两位')
      }
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/parentStarLicense/onlineCourseSection/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { leading: true, trailing: false })
  }
}
</script>
